import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import { I18nText, BreadcrumbItem, Breadcrumbs } from '@welldev-group/react-comp-lib';
import Link from '@welldev-group/rcl-link';
import newsIcon from 'affiliateIcons/news-placeholder.svg';
import newspaperIcon from 'affiliateIcons/newspaper.svg';
import DateTime from '../DateTime';
import SanitizedHTML from '../../../shared/components/SanitizedHTML';

const NewsDetails = ({ isTravelNews, news, urls }) => {
  const image =
    news && news.image_urls.medium ? news.image_urls.medium : newsIcon;
  const header = isTravelNews ? (
    <I18nText id="dashboard.news.travel_news.header" />
  ) : (
    <I18nText id="dashboard.news.welltravel_news.header" />
  );

  const isSmallScreen = window.innerWidth < 767;

  return (
    <div
      className={ClassNames({
        'news-details': isSmallScreen,
        'container news-details': !isSmallScreen,
      })}
    >
      <div className="news-details__header">
        <div>{header}</div>
        <div className="billing__breadcrumbs">
          <Breadcrumbs>
            <BreadcrumbItem linkUrl={urls.dashboardUrl}>
              <I18nText id="sideNav.dashboard" />
            </BreadcrumbItem>
            <BreadcrumbItem linkUrl={urls.newsListUrl}>{header}</BreadcrumbItem>
            <BreadcrumbItem linkUrl={news ? urls.newsUrl : urls.newsListUrl}>
              <I18nText id="dashboard.news.title" />#{news ? news.id : ''}
            </BreadcrumbItem>
          </Breadcrumbs>
        </div>
      </div>
      {news ? (
        <div
          className={ClassNames('col-12', {
            'col-bleed-y': isSmallScreen,
          })}
        >
          <div className="news-details__title">{news.title}</div>
          <div className="col-xlg-2 col-lg-2 col-md-2 col-12 hidden-xlg hidden-lg hidden-md col-bleed">
            <p>
              {isTravelNews && news.author && (
                <>
                  <div className="news-details__info">
                    <I18nText id="dashboard.news.news_by" />
                  </div>
                  <div className="news-details__author">{news.author}</div>
                </>
              )}
              <div className="news-details__info">
                <DateTime dateTime={news.created_at} format="short" />
              </div>
            </p>
          </div>
          <div className="news-details__image">
            <img src={image} alt="news" />
          </div>
          <div>
            <div className="col-xlg-2 col-lg-2 col-md-2 col-12 col-bleed hidden-xxs hidden-xs hidden-sm">
              <p className="news-details__left">
                {isTravelNews && news.author && (
                  <>
                    <div className="news-details__info">
                      <I18nText id="dashboard.news.news_by" />
                    </div>
                    <div className="news-details__author">{news.author}</div>
                  </>
                )}
                <div className="news-details__info">
                  <DateTime dateTime={news.created_at} format="short" />
                </div>
              </p>
            </div>
            <div className="col-xlg-10 col-lg-10 col-md-10 col-12 news-details__container">
              <div className="news-details__body">
                <SanitizedHTML html={news.content} />
              </div>
              {news.external_link && (
                <>
                  <div className="hidden-xxs hidden-xs hidden-sm">
                    <div className="news-details__footer">
                      <div className="news-details__link">
                        <I18nText id="dashboard.news.external_link" />:
                      </div>
                      <a
                        className="news-details__external-link"
                        href={news.external_link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {news.external_link}
                      </a>
                    </div>
                  </div>
                  <div className="hidden-xlg hidden-lg hidden-md">
                    <Link
                      className="news-details__external-link--mobile"
                      href={news.external_link}
                      size="small"
                      type="button"
                      modifier="tertiary"
                      openNewTab={true}
                    >
                      <I18nText id="dashboard.news.external_link" />
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="col-grid align-center justify-center">
          <div className="news-details__image--empty">
            <img src={newspaperIcon} alt="credit-card" />
          </div>
          <div className="news-details__text--empty">
            <I18nText id="dashboard.news.not_found" />
          </div>
        </div>
      )}
    </div>
  );
};

NewsDetails.defaultProps = {
  news: null,
};

NewsDetails.propTypes = {
  isTravelNews: PropTypes.bool.isRequired,
  news: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    author: PropTypes.string,
    content: PropTypes.string,
    external_link: PropTypes.string,
    created_at: PropTypes.string,
    source: PropTypes.string,
    country: PropTypes.shape({
      name: PropTypes.string,
    }),
    image_urls: PropTypes.shape({
      medium: PropTypes.string,
    }),
  }),
  urls: PropTypes.shape({
    newsUrl: PropTypes.string,
    newsListUrl: PropTypes.string.isRequired,
    dashboardUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default NewsDetails;
